import { timestampFormatter } from '@retainerclub/common';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

function TableRowColumnShipping({ productionOrderItems }) {
  const trackingNumbers = useMemo(() => {
    // consolidate productionOrderItems by trackingNumber only to display each unique trackingNumber in an array of obects containing the trackingNumber and the carrier and the trackingUrl

    // also filter out any trackingNumbers that are null or undefined or empty string
    if (!productionOrderItems) {
      return [];
    }

    return productionOrderItems
      .map((item) => ({
        trackingNumber: item.trackingNumber,
        carrier: item.shippingCarrier?.name,
        trackingUrl: item.trackingUrl,
      }))
      .filter(
        (trackingNumber) =>
          trackingNumber.trackingNumber &&
          trackingNumber.trackingNumber !== '' &&
          trackingNumber.trackingNumber !== null &&
          trackingNumber.trackingNumber !== undefined,
      )
      .filter(
        (trackingNumber, index, self) => self.indexOf(trackingNumber) === index,
      );
  }, [productionOrderItems]);

  return (
    <>
      {!productionOrderItems.some((item) => item.deliveredAt) && (
        <>
          <span className="text-base text-gray-700">
            <span className="font-semibold">*Estimated</span> delivery:
          </span>{' '}
          <span className="font-medium">
            {productionOrderItems?.some((item) => item.eta)
              ? productionOrderItems.map((item) => (
                  <span key={item.id}>{item.eta}</span>
                ))
              : ' Awaiting ETA'}
          </span>
        </>
      )}

      {productionOrderItems?.some((item) => item.deliveredAt) && (
        <>
          delivered on:{' '}
          <span className="font-medium">
            {timestampFormatter(
              productionOrderItems.find((item) => item.deliveredAt).deliveredAt,
              false,
            )}
          </span>
        </>
      )}

      {trackingNumbers.length > 0 && (
        <>
          <br />
          {trackingNumbers.map((trackingNumber) => (
            <div key={trackingNumber.trackingNumber}>
              {trackingNumber.carrier}:{' '}
              <a
                href={trackingNumber.trackingUrl}
                target="_blank"
                rel="noreferrer"
                className="text-rcprimary-400 underline"
              >
                {trackingNumber.trackingNumber}
              </a>
            </div>
          ))}
        </>
      )}
    </>
  );
}

TableRowColumnShipping.propTypes = {
  productionOrderItems: PropTypes.array.isRequired,
};

export default TableRowColumnShipping;
